import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "./style.css";

import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

import { createStore } from "redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore, persistReducer } from "redux-persist";

import App from "./App";
import auth from "./app/auth";

import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

library.add(fas);

const persistConfig = { key: "root", storage };
const persistedReducer = persistReducer(persistConfig, auth);
const store = createStore(persistedReducer);
const persistor = persistStore(store);
const rootElement = document.getElementById("root");

ReactDOM.render(
    <StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </StrictMode>,
    rootElement,
);
